import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSidebarStore = defineStore('sidebar', () => {
  const isSidebarOpen = ref(false)
  const isSidebarCollapsed = useStorage('isSidebarCollapsed', false)
  const expandedGroup = useStorage<string | null>('expandedSidebarGroup', null)

  function toggleSidebar() {
    isSidebarOpen.value = !isSidebarOpen.value
  }

  function closeSidebar() {
    isSidebarOpen.value = false
  }

  function toggleCollapsed() {
    isSidebarCollapsed.value = !isSidebarCollapsed.value
  }

  function setCollapsed(value: boolean) {
    isSidebarCollapsed.value = value
  }

  function setExpandedGroup(value: string | null) {
    expandedGroup.value = value
  }

  return {
    isSidebarOpen,
    isSidebarCollapsed,
    expandedGroup,
    toggleSidebar,
    closeSidebar,
    toggleCollapsed,
    setCollapsed,
    setExpandedGroup,
  }
})
